import Repository, { getDefaultCRUDMethods } from "./Repository";

const resource = "/Agence";

export default {
  ...getDefaultCRUDMethods({ resource }),
  generateToken({ companyId, nbToken, applicationId }) {
    const requestBody = {
      nbToken: nbToken,
      applicationId: applicationId
    };
    return Repository.post(
      `${resource}/${companyId}/GenerateToken`,
      requestBody
    );
  }
};
